import React, {ReactElement} from "react";

import {css} from "/src/utils/utils";
import {pickTestComponent, TestContainer} from "/src/utils/ab-testing";

import NotificationBar from "../notification-bar/NotificationBar";
import NavigationItems from "../navigation-items/NavigationItems";

import GDPRContext, {GDPRContextState} from "/src/contexts/GDPRContext";

import * as styles from "./navigation.module.scss";

type NavNodes =
  Queries.ContentfulNavComponentQueryQuery["allContentfulSuperMainNavBars"]["nodes"][0];

interface NavigationProps extends NonNullable<NavNodes> {
  isSticky: boolean;
}

const Navigation = (props: NavigationProps): ReactElement => {
  const {
    alertText,
    promotionalText,
    superNavPromotionalCtaLink,
    superNavPromotionalCtaText,
    superNavPromotionalCtaButton,
    euPromotionalText,
    euSuperNavPromotionalCtaText,
    euSuperNavPromotionalCtaLink,
    euSuperNavPromotionalCtaButton,
    leavePromotionalTextBlankForEu,
    mainNavPrimaryCta,
    euMainNavPrimaryCta,
    mainNavSecondaryCTA,
    euMainNavSecondaryCta,
    navTabs,
    primaryCtaTest,
    secondaryCtaTest,
    isSticky,
  } = props;

  const gdpr = React.useContext<GDPRContextState>(GDPRContext);
  const {isEU} = gdpr;

  // If user is found to be in EU country, show EU Primary CTA with different link
  const geoMainNavPrimaryCta = isEU ? euMainNavPrimaryCta : mainNavPrimaryCta;

  const geoSecondaryNavPrimaryCta = isEU
    ? euMainNavSecondaryCta
    : mainNavSecondaryCTA;

  const primaryCta =
    pickTestComponent(primaryCtaTest as unknown as TestContainer)?.component ||
    geoMainNavPrimaryCta;

  const secondaryCta =
    pickTestComponent(secondaryCtaTest as unknown as TestContainer)
      ?.component || geoSecondaryNavPrimaryCta;

  return (
    <>
      {/* This component pushes the main content down the correct height without having to use a window resize event. */}
      <NotificationBar
        promotionalText={promotionalText}
        superNavPromotionalCtaText={superNavPromotionalCtaText}
        superNavPromotionalCtaLink={superNavPromotionalCtaLink}
        superNavPromotionalCtaButton={superNavPromotionalCtaButton}
        euPromotionalText={euPromotionalText}
        euSuperNavPromotionalCtaText={euSuperNavPromotionalCtaText}
        euSuperNavPromotionalCtaLink={euSuperNavPromotionalCtaLink}
        euSuperNavPromotionalCtaButton={euSuperNavPromotionalCtaButton}
        leavePromotionalTextBlankForEu={leavePromotionalTextBlankForEu}
        alertText={alertText}
        placeholder
      />

      <div
        className={css(
          styles.navigation,
          isSticky ? styles.navigationSticky : ""
        )}
      >
        <NotificationBar
          promotionalText={promotionalText}
          superNavPromotionalCtaText={superNavPromotionalCtaText}
          superNavPromotionalCtaLink={superNavPromotionalCtaLink}
          superNavPromotionalCtaButton={superNavPromotionalCtaButton}
          euPromotionalText={euPromotionalText}
          euSuperNavPromotionalCtaText={euSuperNavPromotionalCtaText}
          euSuperNavPromotionalCtaLink={euSuperNavPromotionalCtaLink}
          euSuperNavPromotionalCtaButton={euSuperNavPromotionalCtaButton}
          leavePromotionalTextBlankForEu={leavePromotionalTextBlankForEu}
          alertText={alertText}
        />

        <NavigationItems
          navTabs={navTabs}
          primaryCTA={primaryCta}
          secondaryCTA={secondaryCta}
        />
      </div>
    </>
  );
};

export default Navigation;
